import ScrollMagic from 'scrollmagic/scrollmagic/minified/ScrollMagic.min';
import 'scrollmagic/scrollmagic/minified/plugins/animation.gsap.min';
import 'scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min';

const controller = new ScrollMagic.Controller();

export default (element, params = {}) => {
    params = Object.assign({
        hook: 0,
        gapBackground: '#000',
        gapOpacity: 1
    }, params);

    const gap = document.createElement('div');

    const setGapStyle = () => {
        const styles = getComputedStyle(element);

        gap.style.background = params.gapBackground;
        gap.style.opacity = params.gapOpacity;
        gap.style.zIndex = styles.zIndex;
        gap.style.pointerEvents = 'none';
    };

    const setGapSize = () => {
        const rect = element.getBoundingClientRect();

        gap.style.width = rect.width + 'px';
        gap.style.height = rect.height + 'px';
        gap.style.minHeight = window.innerHeight * (1 - params.hook) + 'px';
        gap.style.position = 'relative';
    };

    const setGap = () => {
        let prevStyle = {
            zIndex: 0
        };

        if (params.prevElement) {
            prevStyle = getComputedStyle(params.prevElement);
        }

        gap.style.display = 'block';
        gap.style.zIndex = prevStyle.zIndex - 1;
    };

    const unsetGap = () => {
        gap.style.display = 'none';
    };

    const setElement = () => {
        // element.style.overflow = 'hidden';        
        element.style.minHeight = window.innerHeight * (1 - params.hook) + 'px';
    };

    const unsetElement = () => {
        element.style.overflow = '';
        element.style.minHeight = '';
        element.style.position = '';
        element.style.top = '';
        element.style.left = '';
        element.style.zIndex = '';
    };

    const fixElement = () => {

        let prevStyle = {
            zIndex: 0
        };

        if (params.prevElement) {
            prevStyle = getComputedStyle(params.prevElement);
        }

        const winHeight = window.innerHeight * params.hook;

        element.style.position = 'fixed';
        element.style.top = winHeight + 'px';
        element.style.left = 0;
        element.style.zIndex = prevStyle.zIndex - 1;
        setGap();
    };

    const unfixElement = () => {
        element.style.position = 'relative';
        element.style.top = '';
        element.style.left = '';
        unsetGap();
    };

    const getDuration = () => {
        if (gap.style.display !== 'none') {
            const rectGap = gap.getBoundingClientRect();
            return window.pageYOffset + rectGap.top;
        } else {
            const rect = element.getBoundingClientRect();
            return window.pageYOffset + rect.top;
        }
    };

    const setGapOpacity = progress => {
        gap.style.opacity = params.gapOpacity * Math.max(Math.min(progress, 1), 0);
    };

    const scaleNumberRange = (number, oldMin, oldMax, newMin, newMax) => {
        return (newMax - newMin) * (number - oldMin) / (oldMax - oldMin) + newMin;
    };

    element.parentElement.insertBefore(gap, element);
    element.parentElement.insertBefore(element, gap);
    setGapStyle();
    setGapSize();
    setElement();
    fixElement();

    let scene = new ScrollMagic.Scene({
        triggerElement: document.body,
        triggerHook: params.hook,
        duration: getDuration
    });

    scene.on('progress', data => {
        const duration = getDuration();
        const gapProgress = scaleNumberRange(Math.abs(window.pageYOffset - duration + window.innerHeight * params.hook), 0, window.innerHeight * (1 - params.hook), 0, 1);
        setGapOpacity(gapProgress);

        if (data.progress === 1) {
            unfixElement();
        } else {
            fixElement();
        }
    });
    
    // scene.addIndicators({name: 'section 2'})
    scene.addTo(controller);

    const destroy = () => {
        unsetElement();
        gap.parentElement.removeChild(gap);
        scene.destroy(true);
        scene = null;
    };

    return destroy;
};


// WEBPACK FOOTER //
// ./js/makeSectionLikePaper.js